import { Card, CardBody, Col } from "reactstrap";
import { MultiFileUploadTitle } from "../../../constants";
import { FileUploadData } from "../../../data/bonusUi/Dropzone";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import CommonFileUpload from "../../../coreComponents/CommonFileUpload";

const MultiFileUpload = () => {
  return (
    <Col lg="6">
      <Card className="multifile-dropzone">
        <CommonCardHeader title={MultiFileUploadTitle} span={FileUploadData} />
        <CardBody className="dropzone-secondary">
          <CommonFileUpload multiple />
        </CardBody>
      </Card>
    </Col>
  );
};
export default MultiFileUpload;
